<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>Open API</h3>
      </div>
      <div class="box-content">
        <p>
          Basta enviar um request POST para a URL abaixo com os paramétros: first_name, last_name, phone e email no body da mensagem em json.
        </p>
        <form>
          <div>
            <input
              class="input"
              type="text"
              v-model="urlWebhook"
              readonly="true"
            />
          </div>
          <div class="margin-top-s">
            <div class="button primary" @click="copyLink(urlWebhook)">
              Copiar Url
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "kiwify",
  data() {
    return {
      baseUrlWebhook: "https://wh.123mail.com.br/webhook/v1/contact/custom/",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    urlWebhook() {
      return `${this.baseUrlWebhook}${this.account.id}/`;
    },
  },
  mounted() {},
  methods: {
    copyLink(link) {
      let copyText = link;
      navigator.clipboard.writeText(copyText);

      this.$toast.success({
        title: "Sucesso",
        message: "Link do Webhook copiado!",
      });
    },
  },
};
</script>
